var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconAnalyticsSolid extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconAnalytics",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M746.667 106.667H1173.33V1493.33H746.667V106.667ZM533.333 533.333H106.667V1493.33H533.333V533.333ZM1920 1706.67H0V1824H1920V1706.67ZM1813.33 746.667H1386.67V1493.33H1813.33V746.667Z"
    })));
  }
}
IconAnalyticsSolid.glyphName = 'analytics';
IconAnalyticsSolid.variant = 'Solid';
IconAnalyticsSolid.displayName = 'IconAnalyticsSolid';
IconAnalyticsSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconAnalyticsSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconAnalyticsSolid;
export { IconAnalyticsSolid };